import * as React from 'react';
import './Notes.scss';
import PropertyUtil from 'src/util/PropertyUtil';
import Form from 'src/components/controls/forms/Form';
import { Field } from 'react-final-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import FormRow from 'src/components/controls/forms/FormRow';
import TractDetailData from 'src/models/tract_detail/TractDetail';
import Dialog from 'src/components/common/Dialog.redesign';
import SurfaceTract from 'src/models/SurfaceTract';

export interface ITractNotesStateProps {
    tract: TractDetailData | undefined;
    surfaceTract: SurfaceTract | undefined;
    errorMessage: string;
}

export interface ITractNotesDispatchProps {
    clearError: () => void;
    updateTractNote: (horizon: TractDetailData) => void;
    updateSurfaceTractNote: (surfaceTract: SurfaceTract) => void;
    onCloseDialog?: () => void;
}

type ITractNotesPageProps = ITractNotesStateProps & ITractNotesDispatchProps;

class TractNotesDialog extends React.Component<ITractNotesPageProps> {
    constructor(props: ITractNotesPageProps) {
        super(props);
    }

    submitTractNote = (tract: TractDetailData) => {
        if (!!this.props.tract) {
            this.props.updateTractNote(tract);
            this.props.clearError();
            this.props.onCloseDialog();
        }
    };

    submitSurfaceTractNote = (surfaceTract: SurfaceTract) => {
        if (!!this.props.surfaceTract) {
            this.props.updateSurfaceTractNote(surfaceTract);
            this.props.onCloseDialog();
        }
    }

    public render() {
        if (!!this.props.tract) {
            const horizon = PropertyUtil.SafeGet(() => this.props.tract);
    
            return (
                <Dialog title={`Tract Notes`}>
                    <div style={{ color: 'red', height: '3rem' }}>{this.props.errorMessage}</div>
    
                    <Form onSubmit={this.submitTractNote} initialValues={horizon}>
                        <Field name="note" component="textarea" cols={50} rows={20} />
                        <FormRow>
                            <Button type="submit" text="SAVE" intent="primary" />
                        </FormRow>
                    </Form>
                </Dialog>
            );
        } else if (!!this.props.surfaceTract) {
            const surfaceTract = PropertyUtil.SafeGet(() => this.props.surfaceTract);

            return (
                <Dialog title={`Surface Tract Notes`}>
                    <div style={{ color: 'red', height: '3rem' }}>{this.props.errorMessage}</div>
    
                    <Form onSubmit={this.submitSurfaceTractNote} initialValues={surfaceTract}>
                        <Field name="note" component="textarea" cols={50} rows={20} />
                        <FormRow>
                            <Button type="submit" text="SAVE" intent="primary" />
                        </FormRow>
                    </Form>
                </Dialog>
            );
        }
        return (
            <Dialog title={`Invalid Tract Type`}>
                <div style={{ color: 'red', height: '3rem' }}>{this.props.errorMessage}</div>
            </Dialog>
        );
    }
}

export default TractNotesDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/TractNotesDialog.tsx